import {LicenseInfo} from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
   '63290139b3885d05d695e2ea21d8fb0bT1JERVI6MjY3MjksRVhQSVJZPTE2NTY4NjE4NDgwMDAsS0VZVkVSU0lPTj0x'
);
